import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import SignIn from '~/pages/SignIn';
import Home from '~/pages/Home';
import MembersList from '~/pages/Members/List';
import MembersUpdate from '~/pages/Members/Update';
import Calendar from '~/pages/Calendar';
import FaqList from '~/pages/Faq';
import Profile from '~/pages/Profile';
import ProfileBio from '~/pages/Profile/Bio';
import ForgotPassword from '~/pages/ForgotPassword';
import Live from '~/pages/Live';
import LiveVonage from '~/pages/Live/Vonage';

const Default: React.FC = () => {
  return (
    <Switch>
      <Route path={`${process.env.PUBLIC_URL}/`} exact component={SignIn} />
      <Route
        path={`${process.env.PUBLIC_URL}/dashboard`}
        component={Home}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/members`}
        exact
        component={MembersList}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/members/:userID`}
        exact
        component={MembersUpdate}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/calendar`}
        component={Calendar}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/faq`}
        component={FaqList}
        exact
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/profile`}
        component={Profile}
        exact
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/profile/bio/:userID`}
        component={ProfileBio}
        exact
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/forgot-password`}
        exact
        component={ForgotPassword}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/live/:roomID`}
        exact
        isPrivate
        component={Live}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/live-vonage/:roomID`}
        exact
        isPrivate
        component={LiveVonage}
      />
    </Switch>
  );
};

export default Default;
